"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
exports.default = new Network_1.default('avalanche-test', [
    new Token_1.default('avax', 'AVAX', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} AVAX', 'icon/avax.svg'),
    new Token_1.default('ether', 'ETH', 'bifi', 1, '0x0Cac04A2a12125141AA5228d47CE188FB89a13d2', '', false, true, false, [], '{} ETH', 'icon/eth.svg'),
    new Token_1.default('usdt', 'USDT', 'bifi', 2, '0x6c6DeE3832e19E7930A5D14b589f4864d71B1eA6', '', false, true, false, [], '{} USDT', 'icon/usdt.svg'),
    new Token_1.default('link', 'LINK', 'bifi', 4, '0x0102667e2476d70e178703b5B76efA4a2d04c0b3', '', false, true, false, [], '{} LINK', 'icon/link.svg'),
    new Token_1.default('wbtc', 'WBTC', 'bifi', 5, '0x91328F69D780BcAEaEF6c4806Acc6FEd320D2e86', '', false, true, false, [], '{} WBTC', 'icon/wbtc.svg'),
    new Token_1.default('dot', 'DOT', 'bifi', -1, '', '', true, true, true, [], '{} DOT', 'icon/dot.svg'),
    new Token_1.default('kaia', 'KAIA', 'bifi', -1, '', '', true, true, true, [], '{} KAIA', 'icon/kaia.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x8f4223d6554e020472Db416dA752Cc84728ba733', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'avax'),
    new Handler_1.default(1, 'ether'),
    new Handler_1.default(2, 'usdt'),
    new Handler_1.default(3, 'link'),
    new Handler_1.default(4, 'wbtc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('srd.market', 'marketInformation(uint256,uint256)', [
        'blockNumber.from',
        'blockNumber.to'
    ], ['(uint256,uint256,uint256,uint256)']),
    new Method_1.default('srd.user', 'userInformation(address,uint256,uint256)', [
        'user.address',
        'blockNumber.from',
        'blockNumber.to'
    ], ['(uint256,uint256,uint256,uint256,uint256)'])
], [
    new EntryPoint_1.default('bifi', '0xaB981a3169CC9b56C5bfEaCB09e325AFd8C28eBF')
], 2000);
//# sourceMappingURL=avalanche-test.js.map